import React, { useState } from "react";
import "./ActionButtons.css";

function ActionButtons({ modalData, setModalData }) {

  const [activeBtn, setActiveBtn] = useState("1");

  // Logic for Big and Small buttons
  const handleSelectionClick = (value) => {
    const type = value === "Big" ? "orange" : "blue";

    if (setModalData) {
      setModalData({
        ...modalData,
        open: true,
        value: value,
        type: type,
        multiply: activeBtn,
        bet_type: "size",

      });
    }
  };
  const handleMultiplierClick = (value) => {
    if (value === "Random") {
      const numbers = ["1", "5", "10", "20", "50", "100"];
      const randomValue = numbers[Math.floor(Math.random() * numbers.length)];
      setModalData({
        ...modalData, multiply: randomValue, bet_type: "size",
      })
      setActiveBtn(randomValue);
      return;
    }

    setActiveBtn(value);
    setModalData({
      ...modalData, multiply: value, bet_type: "size",
    })
  };

  return (
    <>
      <section className="ActionButtons">

        <div className="random_buttons">
          <button
            className={`random_btn ${activeBtn === "Random" ? "active" : ""}`}
            onClick={() => handleMultiplierClick("Random")}
          >
            Random
          </button>

          <button
            className={activeBtn === "1" ? "active" : ""}
            onClick={() => handleMultiplierClick("1")}
          >
            X1
          </button>

          <button
            className={activeBtn === "5" ? "active" : ""}
            onClick={() => handleMultiplierClick("5")}
          >
            X5
          </button>

          <button
            className={activeBtn === "10" ? "active" : ""}
            onClick={() => handleMultiplierClick("10")}
          >
            X10
          </button>

          <button
            className={activeBtn === "20" ? "active" : ""}
            onClick={() => handleMultiplierClick("20")}
          >
            X20
          </button>
          <button
            className={activeBtn === "50" ? "active" : ""}
            onClick={() => handleMultiplierClick("50")}
          >
            X50
          </button>
          <button
            className={activeBtn === "100" ? "active" : ""}
            onClick={() => handleMultiplierClick("100")}
          >
            X100
          </button>
        </div>

        <div className="big_small">
          <button
            className="big_btn big_btn_holder"
            onClick={() => handleSelectionClick("Big")}
          >
            Big
          </button>

          <button
            className="small_btn big_btn_holder"
            onClick={() => handleSelectionClick("Small")}
          >
            Small
          </button>
        </div>

      </section>
    </>
  );
}

export default ActionButtons;